import {
  FETCH_NIFI_REPORT_REQUEST,
  FETCH_NIFI_REPORT_SUCCESS,
  FETCH_NIFI_REPORT_ERROR,
  FETCH_NIFI_TRENDS_REQUEST,
  FETCH_NIFI_TRENDS_SUCCESS,
  FETCH_NIFI_TRENDS_ERROR,
  SET_NIFI_REPORT_FILTERS
} from '../actions/nifiReport';

interface NifiReportState {
  data: any;
  trendsData: any[];
  loading: boolean;
  trendsLoading: boolean;
  error: string | null;
  trendsError: string | null;
  filters: {
    apps: string;
    source?: string;
    startDate?: string;
    endDate?: string;
  };
}

const initialState: NifiReportState = {
  data: null,
  trendsData: [],
  loading: false,
  trendsLoading: false,
  error: null,
  trendsError: null,
  filters: {
    apps: 'Nifi',
    source: '',
    startDate: '',
    endDate: ''
  }
};

const nifiReportReducer = (state = initialState, action: any): NifiReportState => {
  switch (action.type) {
    case FETCH_NIFI_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_NIFI_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case FETCH_NIFI_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_NIFI_TRENDS_REQUEST:
      return {
        ...state,
        trendsLoading: true,
        trendsError: null
      };
    case FETCH_NIFI_TRENDS_SUCCESS:
      return {
        ...state,
        trendsLoading: false,
        trendsData: action.payload,
        trendsError: null
      };
    case FETCH_NIFI_TRENDS_ERROR:
      return {
        ...state,
        trendsLoading: false,
        trendsError: action.payload
      };
    case SET_NIFI_REPORT_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload }
      };
    default:
      return state;
  }
};

export default nifiReportReducer;
